import { api } from "@/api";

export interface ImportedEvent {
  id: number;
  providerEventId: number;
  type: "goal" | "card" | "corner" | "penalty";
  minute: number;
  seconds: number;
  period: number;
  participant: "team1" | "team2";
  cardType: "yellow" | "red" | "yellow_red" | null;
  side: "left" | "right" | null;
  // Only meaningful on goal events — set when the goal was scored from a
  // penalty kick. Mirrors the backend's ImportedGoalMethod (Tasks 6-9).
  method: "penalty" | null;
}

export interface ImportedTeamStats {
  score: number;
  yellowCards: number;
  redCards: number;
  corners: number;
}

export interface ImportedPeriodStats {
  periodNumber: number;
  stats: {
    team1: ImportedTeamStats;
    team2: ImportedTeamStats;
  };
}

export type ImportedLivePhase = "1H" | "HT" | "2H" | "ET" | "PEN";

export interface ImportedEventBundle {
  source: string;
  events: ImportedEvent[];
  participants: {
    team1: ImportedTeamStats;
    team2: ImportedTeamStats;
  };
  periods: ImportedPeriodStats[];
  meta?: {
    matchTitle?: string;
    finalScore?: string;
    homeTeamName?: string;
    awayTeamName?: string;
    matchState?: string;
    /**
     * Where a LIVE race is (football sources): first half, half-time, second
     * half, extra time, penalties. Absent / null when the source does not say
     * (basketball, a finished or not-started race).
     */
    livePhase?: ImportedLivePhase | null;
    /**
     * Event types the SOURCE cannot deliver at all (not "this match had
     * none") — e.g. Sofascore publishes no corners. Shown as a note after an
     * import so a zero count is never read as verified data.
     */
    unsupportedEventTypes?: ImportedEvent["type"][];
  };
}

export interface ImportMatchEventsPayload {
  url: string;
}

export const importMatchEvents = async (
  matchId: string,
  payload: ImportMatchEventsPayload
): Promise<ImportedEventBundle> => {
  const res = await api.client.post(
    `/matches/${matchId}/import-events`,
    payload
  );
  return res.data;
};
